import { ErrorSmallPopup } from '../popups/errorSmallPopup';
import { WebPreloader } from '../popups/webPreloader';
import { Localization } from '../localization/localization';
import { getUrlToLoginViaToken } from '../login/getUrlToLoginViaToken';
import { container } from '../utils/container/container';
import { ServiceIds } from '../utils/container/service-ids';
import { FeatureFlagsLoader } from '../utils/feature-flags/feature-flags-loader';
import { FlagNames } from '../utils/feature-flags/flag-names';
import { CurrentEntryPoint } from '../constants/CurrentEntryPoint';

// The flag is set per environment, not per entry point, so the closing platforms are listed here.
const CLOSING_ENTRY_POINTS: CurrentEntryPoint[] = [CurrentEntryPoint.FB, CurrentEntryPoint.FB2];

export class FbClosurePopup {
    public static isActive(): boolean {
        if (!CLOSING_ENTRY_POINTS.includes(window.app.config.current_entry_point)) {
            return false;
        }

        const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
        return ffLoader.get(FlagNames.FB_PLATFORM_CLOSURE).isOn();
    }

    public static show(): boolean {
        if (!FbClosurePopup.isActive()) {
            return false;
        }

        const popup = ErrorSmallPopup.getInstance();
        popup.enableCloseBtn();
        popup.setTitle(Localization._n('fb_closure.popup_header'));
        popup.setMessage(Localization.nl2br(Localization._n('fb_closure.popup_body')), true);
        popup.setButtonText(Localization._n('fb_closure.popup_button'));
        popup.setCallback(FbClosurePopup.continueOnSite);
        popup.show();
        return true;
    }

    private static continueOnSite(): void {
        WebPreloader.enable();

        try {
            window.top.location.href = FbClosurePopup.getContinueUrl();
        } catch (error) {
            // setCallback has already hidden the popup, so bring it back instead of the bare loader.
            WebPreloader.disable();
            window.Sentry.captureException(error);
            FbClosurePopup.show();
        }
    }

    // getUser() rewrites user_auth_token on every GetGameStartData, so the url is built on click.
    private static getContinueUrl(): string {
        const url = getUrlToLoginViaToken(
            window.app.config.user_auth_token,
            window.app.config.suid
        );

        return `${url}&state=switchAccount`;
    }
}
